import React from "react";

const Copyright = () => (
  <p className="text-center">
    {"Copyright © "}
    <a href="https://goconvey.com" target="_blank" rel="noreferrer">
      Convey
    </a>{" "}
    {new Date().getFullYear()}
    {"."}
  </p>
);

export default Copyright;
